import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const  downloadPDF = createAsyncThunk(
  "/downloadPDF",
  async ( plan_id , { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`/generate-visual-rep-pdf/${plan_id}`, {
        
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch pdf");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching pdf "
      );
    }
  }
);

const downloadPDFSlice = createSlice({
  name: "downloadPDF",
  initialState: { 
    PdfLink :{} ,
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase( downloadPDF.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase( downloadPDF.fulfilled, (state, action) => {
        console.log("payload : " + JSON.stringify(action.payload)) ;
        state.status = "succeeded";
        state.PdfLink = action.payload.data;
        state.loading = false;
      })
      .addCase( downloadPDF.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default downloadPDFSlice.reducer;
